// removed by extract-text-webpack-plugin
module.exports = {"miniChart":"antd-pro-miniChart","chartContent":"antd-pro-chartContent","chartLoading":"antd-pro-chartLoading"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/index.less
// module id = 114
// module chunks = 0 1